import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1604dc19&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1604dc19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1604dc19')) {
      api.createRecord('1604dc19', component.options)
    } else {
      api.reload('1604dc19', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1604dc19&scoped=true&", function () {
      api.rerender('1604dc19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/base-config/goods-operation/modules/table-list/index.vue"
export default component.exports